const type = 'SAVE_CUSTOMER_ONBOARD_ACCOUNT_DATA';

const saveCustomerOnboardAccountData = (data) => ({
  data,
  type,
});

export { type };
export default saveCustomerOnboardAccountData;
